import { motion } from "framer-motion";
import { SectionHeader } from "@/components/site/SectionHeader";
import { fadeUp, staggerParent, viewport } from "@/lib/motion";

const steps = [
  {
    n: "01",
    title: "Choose an asset or opportunity",
    desc: "Select a cryptocurrency, a watchlist item or a presale you want to understand more deeply.",
  },
  {
    n: "02",
    title: "Let Velora Intelligence analyze",
    desc: "Our AI reviews the available market intelligence — technical factors, risk signals and context — to produce clear scores and outlooks.",
  },
  {
    n: "03",
    title: "Make your own informed decision",
    desc: "Use the resulting insights, risk information and monitoring tools to decide with confidence and full context.",
  },
];

export const HowItWorks = () => (
  <section
    id="how-it-works"
    className="relative z-10 mx-auto max-w-6xl scroll-mt-24 px-4 py-24 sm:px-6 md:py-32"
    data-testid="how-it-works-section"
  >
    <SectionHeader
      label="How It Works"
      title="Three steps to clearer decisions"
    />
    <motion.div
      variants={staggerParent}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      className="mt-16 grid gap-8 md:grid-cols-3"
    >
      {steps.map((s, i) => (
        <motion.div
          key={s.n}
          variants={fadeUp}
          className="relative"
          data-testid={`step-${s.n}`}
        >
          <div className="flex items-baseline gap-4">
            <span className="font-display text-6xl font-extrabold leading-none text-transparent [-webkit-text-stroke:1.5px_rgba(0,229,255,0.5)]">
              {s.n}
            </span>
            {i < steps.length - 1 && (
              <span className="hidden h-px flex-1 bg-gradient-to-r from-teal-500/40 to-transparent md:block" />
            )}
          </div>
          <h3 className="mt-6 font-display text-xl font-bold text-white md:text-2xl">
            {s.title}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-white/55 md:text-base">
            {s.desc}
          </p>
        </motion.div>
      ))}
    </motion.div>

    <motion.p
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      className="mt-14 rounded-2xl border border-white/8 bg-white/[0.02] p-5 text-center text-sm text-white/50"
    >
      Velora Intelligence provides analytical intelligence and does not
      guarantee investment outcomes. Always make your own informed decisions.
    </motion.p>
  </section>
);
